import Vue from 'vue';

export const clientContactService = {
  async getClientContact(reference_number) {
    return Vue.axios.get('/client-contact/' + reference_number);
  },
  async getClientContactAssignments(reference_number, sortOrder) {
    return Vue.axios
      .get(`/client-contact/${reference_number}/assignments`, {
        params: {
          ...sortOrder
        }
      })
      .then(response => response.data);
  },
  async saveClientContact(clientContact) {
    return Vue.axios.post('/client-contact', clientContact).then(response => response.data);
  }
};
